import {CaretPosition, EditorFrameObjects, RootContainerFrameDefinition, ImportsContainerDefinition, FuncDefContainerDefinition, MainFramesContainerDefinition, getFrameDefType, AllFrameTypesIdentifier} from "@/types/types";

const initialTestState: EditorFrameObjects = {
    0: {
        id: 0,
        frameType : RootContainerFrameDefinition,
        isDisabled: false,
        isSelected: false,
        isVisible: true,
        parentId: 0,
        childrenIds: [-1, -2, -3],
        jointParentId: 0,
        jointFrameIds: [],
        labelSlotsDict: { },
        caretVisibility: CaretPosition.none,
    },
    "-1": {
        id: -1,
        frameType : ImportsContainerDefinition,
        isDisabled: false,
        isSelected: false,
        isVisible: true,
        parentId: 0,
        childrenIds: [],
        jointParentId: 0,
        jointFrameIds: [],
        labelSlotsDict: {},
        isCollapsed: false,
        caretVisibility: CaretPosition.none,
    },
    "-2": {
        id: -2,
        frameType : FuncDefContainerDefinition,
        isDisabled: false,
        isSelected: false,
        isVisible: true,
        parentId: 0,
        childrenIds: [],
        jointParentId: 0,
        jointFrameIds: [],
        labelSlotsDict: { },
        isCollapsed: false,
        caretVisibility: CaretPosition.none,
    },
    "-3": {
        id: -3,
        frameType : MainFramesContainerDefinition,
        isDisabled: false,
        isSelected: false,
        isVisible: true,
        parentId: 0,
        childrenIds: [1,5,6,7],
        jointParentId: 0,
        jointFrameIds: [],
        labelSlotsDict: {},
        isCollapsed: false,
        caretVisibility: CaretPosition.body,
    },

    1: {
        frameType: getFrameDefType(AllFrameTypesIdentifier.if),
        id: 1,
        isDisabled: false,
        isSelected: false,
        isVisible: true,
        parentId: -3,
        childrenIds: [2],
        jointParentId: 0,
        jointFrameIds: [3],
        labelSlotsDict: {0: {slotStructures: {operators: [{code: ">"}], fields: [{code: "1"}, {code: "0"}]}}},
        caretVisibility: CaretPosition.none,
    },

    2: {
        frameType: getFrameDefType(AllFrameTypesIdentifier.funccall),
        id: 2,
        isDisabled: false,
        isSelected: false,
        isVisible: true,
        parentId: 1,
        childrenIds: [],
        jointParentId: 0,
        jointFrameIds: [],
        labelSlotsDict: {0: {slotStructures: {operators: [{code: "="}], fields: [{code: "a"}, {code: "2"}]}}},
        caretVisibility: CaretPosition.none,
    },
    3: {
        frameType: getFrameDefType(AllFrameTypesIdentifier.elif),
        id: 3,
        isDisabled: false,
        isSelected: false,
        isVisible: true,
        parentId: 0,
        childrenIds: [4],
        jointParentId: 1,
        jointFrameIds: [],
        labelSlotsDict: {0: {slotStructures: {operators: [], fields: [{code: "3"}]}}}, //?
        caretVisibility: CaretPosition.none,
    },
    4: {
        frameType: getFrameDefType(AllFrameTypesIdentifier.funccall),
        id: 4,
        isDisabled: false,
        isSelected: false,
        isVisible: true,
        parentId: 3,
        childrenIds: [],
        jointParentId: 0,
        jointFrameIds: [],
        labelSlotsDict: {0: {slotStructures: {operators: [{code: "="}], fields: [{code: "a"}, {code: "4"}]}}},
        caretVisibility: CaretPosition.none,
    },
    5: {
        frameType: getFrameDefType(AllFrameTypesIdentifier.funccall),
        id: 5,
        isDisabled: false,
        isSelected: false,
        isVisible: true,
        parentId: -3,
        childrenIds: [],
        jointParentId: 0,
        jointFrameIds: [],
        labelSlotsDict: {0: {slotStructures: {operators: [{code: ""}, {code: ""}], fields: [{code: "print"}, {openingBracketValue: "(", fields: [{code: "5"}], operators: []}, {code : ""}]}}},
        caretVisibility: CaretPosition.none,
    },
    6: {
        frameType: getFrameDefType(AllFrameTypesIdentifier.funccall),
        id: 6,
        isDisabled: false,
        isSelected: false,
        isVisible: true,
        parentId: -3,
        childrenIds: [],
        jointParentId: 0,
        jointFrameIds: [],
        labelSlotsDict: {0: {slotStructures: {operators: [{code: "="}], fields: [{code: "x"}, {code: "6"}]}}},
        caretVisibility: CaretPosition.none,
    },
    7: {
        frameType: getFrameDefType(AllFrameTypesIdentifier.funccall),
        id: 7,
        isDisabled: false,
        isSelected: false,
        isVisible: true,
        parentId: -3,
        childrenIds: [],
        jointParentId: 0,
        jointFrameIds: [],
        labelSlotsDict: {0: {slotStructures: {operators: [{code: "="}], fields: [{code: "a"}, {code: "7"}]}}},
        caretVisibility: CaretPosition.none,
    },
};

export default initialTestState;


